export const PROFILES = {
    'low-vision-profile': {
        "contrast": 'high-contrast',
        "tools": ['font-size', 'page-read'],
    },
    'adhd-profile': {
        "contrast": 'high-saturation',
        "tools": ['stop-animations', 'readable-guide'],
    },
    'seizure-safe-profile': {
        "contrast": 'monochrome',
        "tools": ['stop-animations'],
    },
    'epilepsy-safe-profile': {
        "contrast": 'monochrome',
        "tools": ['stop-animations', 'mute-sounds'],
    },
}
